const global = window

inputs.types.btn = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.type == 'btn') {
        input.click(function (e) {
            if (input.attr('disabled') !== undefined) {
                e.preventDefault();
                return false;
            }
            if (data) {
                switch (data.action) {
                case 'prev':
                    var tabs = input.closest('.tabs');
                    var tab = input.closest('.tabs__pane');
                    if (tabs && tab) inputs.fn.tabs.set(tabs, tab.prev());
                    e.preventDefault();
                    break;
                case 'next':
                    var tabs = input.closest('.tabs');
                    var tab = input.closest('.tabs__pane');
                    if (tabs && tab) inputs.fn.tabs.set(tabs, tab.next());
                    e.preventDefault();
                    break;
                case 'submit':
                    
                    break;
                default:
                    break;
                }
            }
        })
    }
    return data
}
